import { IDisposable } from "../../utils/disposable";
import { expressEventListener } from "../../common/html";
import { isSafari } from "../../common/browser";
import { getCookie } from "../../utils/cookie";

export interface ICookieWatcher {
	start: () => void;
	stop: () => void;
}
export default async function WatchCookie(
	cookieName: string,
	onCookieChange: (cookieValue: string) => void,
): Promise<ICookieWatcher> {
	const supportsCookieStoreApi = "cookieStore" in window !== undefined && !isSafari();
	try {
		return supportsCookieStoreApi
			? await WatchCookieWithCookieStore(cookieName, onCookieChange)
			: await WatchCookieWithInterval(cookieName, onCookieChange);
	} catch {
		// fallback to old implementation
		return await WatchCookieWithInterval(cookieName, onCookieChange);
	}
}

async function WatchCookieWithCookieStore(
	cookieName: string,
	onCookieChange: (cookieValue: string) => void,
): Promise<ICookieWatcher> {
	let disposableEvent: IDisposable | null;
	const initialCookieValue = await cookieStore.get(cookieName);
	const start = () => {
		disposableEvent = expressEventListener(cookieStore, "change", async (event) => {
			const cookieToWatch = await cookieStore.get(cookieName);

			if (!cookieToWatch || cookieToWatch.value === initialCookieValue) return;
			onCookieChange(cookieToWatch.value);
		});
	};

	return {
		start,
		stop: () => disposableEvent.dispose(),
	};
}

async function WatchCookieWithInterval(
	cookieName: string,
	onCookieChange: (cookieValue: string) => void,
): Promise<ICookieWatcher> {
	let timerId = -1;
	const initialCookieValue = getCookie(cookieName);
	const start = () => {
		clearInterval(timerId);

		// @ts-ignore
		timerId = setInterval(() => {
			const cookieToWatch = getCookie(cookieName);

			if (cookieToWatch === initialCookieValue) return;
			onCookieChange(cookieToWatch);
		}, 1500);
	};

	return {
		start,
		stop: () => clearInterval(timerId),
	};
}
